import styled from "styled-components";
import { GrayColors } from "@smartsuite/types";

export const FooterWrap = styled.div`
  border-top: 1px solid ${GrayColors["G-1"]};
  background-color: ${GrayColors["G-0-5"]};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 8px 12px 10px;
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 6px;
`;
